import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Store} from '../../models/store';
import {environment} from '../../env';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  constructor(private http: HttpClient) {
  }

  stores(householdId: number): Observable<Store[]> {
    return this.http.get<Store[]>(`${environment.apiUrl}/households/${householdId}/stores`);
  }

  store(storeId: number): Observable<Store> {
    return this.http.get<Store>(`${environment.apiUrl}/stores/${storeId}`);
  }

  add(householdId: number, store: Store): Observable<string> {
    return this.http.post<string>(`${environment.apiUrl}/households/${householdId}/stores`, store);
  }

  update(storeId: number, store: Store): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}/stores/${storeId}`, store);
  }

  delete(storeId: number): Observable<any> {
    return this.http.delete<any>(`${environment.apiUrl}/stores/${storeId}`);
  }

}
